import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

type Props = {
  path: string;
};

export default function BackLink({ path }: Props) {
  const { t } = useTranslation();

  return (
    <Link
      to={path}
      className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-primary/30 text-primary hover:bg-primary/10 hover:shadow-sm transition-all"
    >
      <ArrowLeft className="w-4 h-4" />
      <span className="font-medium">{t("back")}</span>
    </Link>
  );
}
